import { createReducer } from '../../utilities/miscellaneous'

// viewport initial state
export const INITIAL_STATE = {
  viewport: null,
}

export const LOAD = 'viewport/LOAD'
export const REFRESH = 'viewport/REFRESH'

// load :: String -> Action.LOAD
export const load = viewport => ({
  type: LOAD,
  viewport,
})

// refresh :: String -> Action.REFRESH
export const refresh = viewport => ({
  type: REFRESH,
  viewport,
})

export default createReducer(INITIAL_STATE, {
  [LOAD]: (state, { viewport }) => ({
    ...state,
    viewport,
  }),

  [REFRESH]: (state, { viewport }) => ({
    ...state,
    viewport,
  }),
})
